import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFold = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 1.75V6.43931L9.28033 4.46964C8.98744 4.17675 8.51256 4.17675 8.21967 4.46964C7.92678 4.76253 7.92678 5.23741 8.21967 5.5303L11.4697 8.7803C11.7626 9.07319 12.2374 9.07319 12.5303 8.7803L15.7803 5.5303C16.0732 5.23741 16.0732 4.76253 15.7803 4.46964C15.4874 4.17675 15.0126 4.17675 14.7197 4.46964L12.75 6.43931V1.75C12.75 1.33579 12.4142 1 12 1C11.5858 1 11.25 1.33579 11.25 1.75Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 15C12.1989 15 12.3897 15.079 12.5303 15.2197L15.7803 18.4697C16.0732 18.7626 16.0732 19.2374 15.7803 19.5303C15.4874 19.8232 15.0126 19.8232 14.7197 19.5303L12.75 17.5607V22.25C12.75 22.6642 12.4142 23 12 23C11.5858 23 11.25 22.6642 11.25 22.25V17.5607L9.28033 19.5303C8.98744 19.8232 8.51256 19.8232 8.21967 19.5303C7.92678 19.2374 7.92678 18.7626 8.21967 18.4697L11.4697 15.2197C11.6103 15.079 11.8011 15 12 15Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5 11.25C11.0858 11.25 10.75 11.5858 10.75 12C10.75 12.4142 11.0858 12.75 11.5 12.75H12.5C12.9142 12.75 13.25 12.4142 13.25 12C13.25 11.5858 12.9142 11.25 12.5 11.25H11.5Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.75 12C2.75 11.5858 3.08579 11.25 3.5 11.25H4.5C4.91421 11.25 5.25 11.5858 5.25 12C5.25 12.4142 4.91421 12.75 4.5 12.75H3.5C3.08579 12.75 2.75 12.4142 2.75 12Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5 11.25C15.0858 11.25 14.75 11.5858 14.75 12C14.75 12.4142 15.0858 12.75 15.5 12.75H16.5C16.9142 12.75 17.25 12.4142 17.25 12C17.25 11.5858 16.9142 11.25 16.5 11.25H15.5Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 12C6.75 11.5858 7.08579 11.25 7.5 11.25H8.5C8.91421 11.25 9.25 11.5858 9.25 12C9.25 12.4142 8.91421 12.75 8.5 12.75H7.5C7.08579 12.75 6.75 12.4142 6.75 12Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 11.25C19.0858 11.25 18.75 11.5858 18.75 12C18.75 12.4142 19.0858 12.75 19.5 12.75H20.5C20.9142 12.75 21.25 12.4142 21.25 12C21.25 11.5858 20.9142 11.25 20.5 11.25H19.5Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgFold;
